export const generateWhatsAppApiUrl = (message): string => {
  return `https://api.whatsapp.com/send?text=${message}`
}

export const generateFacebookApiUrl = (message, url): string => {
  return `https://www.facebook.com/sharer/sharer.php?quote=${message}&u=${url}`
}
